module.exports = __webpack_public_path__ + "static/sw-artwork-6b7e2576df3f9ea29860fcf3c8ea7982.png";